(() => {
  const initialize = root => {
    const requestedVariant = new URLSearchParams(window.location.search).get('variant');
    root.querySelectorAll('[data-jig-restock-variant]').forEach(select => {
      if (select.dataset.jigReady) return;
      select.dataset.jigReady = 'true';
      const option = Array.from(select.options).find(item => item.dataset.variantId === requestedVariant);
      select.value = option ? option.value : '';
      const preserveSelection = () => {
        const selected = select.options[select.selectedIndex];
        const url = new URL(window.location.href);
        if (selected?.dataset.variantId) url.searchParams.set('variant', selected.dataset.variantId);
        else url.searchParams.delete('variant');
        url.hash = select.form.id;
        window.history.replaceState(window.history.state, '', url);
        const returnTo = select.form.querySelector('input[name="return_to"]');
        if (returnTo) returnTo.value = url.pathname + url.search + url.hash;
      };
      select.addEventListener('change', preserveSelection);
      select.form.addEventListener('submit', preserveSelection);
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
